import { Controller } from "@hotwired/stimulus";
import { Dropdown } from 'flowbite';

export default class extends Controller {
  static values = { init: Boolean };
  declare readonly initValue: boolean;
  static targets = [ 'trigger' ];
  declare readonly triggerTarget: HTMLButtonElement;
  declare readonly hasTriggerTarget: boolean;

  get dropdownToggles() {
    const trigger = this.hasTriggerTarget ? this.triggerTarget : this.element.querySelector('[data-dropdown-toggle]');
    return trigger?.getAttribute('data-dropdown-toggle');
  }

  get dropdownEl() {
    const id = this.dropdownToggles;
    return !!id?.length ? document.getElementById(id) : null;
  }

  get dropdownInstance() {
    const id = this.dropdownToggles;
    if (!id?.length) return;
    return (window as any).FlowbiteInstances.getInstance('Dropdown', id);
  }

  connect() {
    if (!this.initValue) return;
    new Dropdown(this.dropdownEl, this.triggerTarget);
    this.addClickListeners();
  }

  disconnect() {
    this.hideDropdown()();
    this.removeClickListeners();
  }

  hideDropdown = (that = null) => () => {
    const dropdown = (that ?? this).dropdownInstance;
    if (dropdown) dropdown.hide();
  }

  removeClickListeners = () => {
    const dropdown = this.dropdownEl;
    if (!dropdown) return;
    const els = [ ...dropdown.querySelectorAll('a'), ...dropdown.querySelectorAll('form button[type="submit"]') ];
    els.forEach(el => el.removeEventListener('click', this.hideDropdown(this)));
  }

  addClickListeners = () => {
    const dropdown = this.dropdownEl;
    if (!dropdown) return;
    const els = [ ...dropdown.querySelectorAll('a'), ...dropdown.querySelectorAll('form button[type="submit"]') ];
    els.forEach(el => el.addEventListener('click', this.hideDropdown(this)));
  }
}
